<template>
    <svg
        id="Lock_open"
        data-name="Lock open"
        xmlns="http://www.w3.org/2000/svg"
        width="15.5"
        height="19.15"
        viewBox="0 0 15.5 19.15"
    >
        <path
            id="Pfad_383"
            data-name="Pfad 383"
            d="M34.247,19.15h-13A1.254,1.254,0,0,1,20,17.9V8.9A1.254,1.254,0,0,1,21.252,7.65h13A1.254,1.254,0,0,1,35.5,8.9V17.9a1.254,1.254,0,0,1-1.253,1.253M21.5,17.65H34V9.15H21.5Z"
            transform="translate(-20)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_384"
            data-name="Pfad 384"
            d="M32.435,6.063a.75.75,0,0,1-.75-.75,3.77,3.77,0,0,0-1.147-2.694.75.75,0,1,1,1.054-1.067,5.259,5.259,0,0,1,1.593,3.761.75.75,0,0,1-.75.75"
            transform="translate(-20)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_385"
            data-name="Pfad 385"
            d="M23.815,8.55h-1.5V5.313A5.378,5.378,0,0,1,27.745,0a5.467,5.467,0,0,1,3.843,1.549L30.542,2.623a3.979,3.979,0,0,0-2.8-1.123,3.878,3.878,0,0,0-3.93,3.813Z"
            transform="translate(-20)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_386"
            data-name="Pfad 386"
            d="M29.25,12.4a1.5,1.5,0,1,1-1.5-1.5,1.5,1.5,0,0,1,1.5,1.5"
            transform="translate(-20)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_387"
            data-name="Pfad 387"
            d="M28.62,13.241l.343,2.077a.5.5,0,0,1-.494.582H27.032a.5.5,0,0,1-.494-.582l.34-2.067"
            transform="translate(-20)"
            :class="fillClass + ' transition-fill'"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "LockIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
        },
    },
});
</script>
